// extracted by mini-css-extract-plugin
module.exports = {"root":"token_root__1lnGj"};